/**
 * Suspense fallback shown while a lazily-loaded route chunk is fetched.
 * Intentionally minimal so it adds no weight to the initial bundle.
 */
export function RouteFallback() {
  return (
    <output className="flex h-full w-full items-center justify-center p-8 text-sm text-muted-foreground">
      Loading…
    </output>
  );
}
